import { FC, lazy } from 'react';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { useGetAssignedShipperAdmins } from 'src/pages/shippers/details/admins/use-get-assigned-shipper-admins';
import { ShipperByIdRequest } from 'src/pages/shippers/details/admins/use-shipper-by-id';

const Page = lazy(() => import('./page'));

type Props = {
  shipper: ShipperByIdRequest;
};

export const ShipperAdmins: FC<Props> = ({ shipper }) => {
  const organisationService = useOrganisationService();
  const admins = useGetAssignedShipperAdmins(organisationService, shipper);
  return <Page shipper={shipper} admins={admins} />;
};
